import { isEmpty } from 'lodash'

import visaImg from '../assets/images/payment/visa.png'
import masterCardImg from '../assets/images/payment/mastercard.png'
import americanExpressImg from '../assets/images/payment/americanexpress.png'

export const getClassOrderStatus = status => {
    let classRender = ''
    switch(status.codeName) {
        case 'PENDIENTE_DE_PAGO':
        case 'PAGADO_PARCIAL':
        case 'SURTIDO_PARCIAL':
        case 'SOLICITUD_DE_DEVOLUCION':
        case 'DEVOLUCION_EN_PROCESO':
            classRender = 'status-yellow'
            break
        case 'PAGADO':
        case 'SURTIDO':
        case 'EMBARCADO':
        case 'ENTREGADO':
        case 'OCURRE':
        case 'DEVOLUCION_RECIBIDA':
        case 'REEMBOLSADO':
            classRender = 'status-green'
            break
        case 'NO_SURTIDO':
        case 'ENTREGA_FALLIDA':
        case 'CANCELADO':
        case 'DEVOLUCION_NO_ACEPTADA':
            classRender = 'status-red'
            break
        default:
            classRender = 'status-yellow'
    }
    return classRender
}

export const getUrlOfDefaultProductImage = () => 'https://storage.googleapis.com/vendora-storage/assets/images/default-product-img.png'

export const getImagesOfProduct = (gallery) => {
    const images = []
    if (!isEmpty(gallery)) {
        for (const item of gallery) {
            if (!isEmpty(item.fileName)) {
                images.push(item.fileName)
            }
        }
    }

    return images
}

export const getImageBrandCard = (brand) => {
    if (brand === 'visa') {
        return visaImg
    } else if (brand === 'mastercard') {
        return masterCardImg
    } else if (brand === 'amex') {
        return americanExpressImg
    }
    return null
}
